const getValue = (key) => sessionStorage && sessionStorage.getItem(key)

export const getCountryCode = () => getValue('countryCode')
export const getIntegratorName = () => getValue('integratorName')
export const getSessionId = () => getValue('sessionId')
export const openNewTab = (path) => {
  const window = global.window.open(path, '_blank')

  window.focus()
}

// localStorage
const getStoredValue = (key) => localStorage && localStorage.getItem(key)
const storeValue = (key, value) => localStorage && localStorage.setItem(key, value)
// localStorage items
const toInitializeCookieAccepted = 'toInitializeCookieAccepted'
const uniqueCookieId = 'uniqueCookieId'

export const getStoredToInitializeCookieAccepted = () => JSON.parse(getStoredValue(toInitializeCookieAccepted))
export const storeToInitializeCookieAccepted = (value) => storeValue(toInitializeCookieAccepted, value)

export const getStoredUniqueCookieId = () => getStoredValue(uniqueCookieId)
